import styled from 'styled-components'
import MessageInput from '~/components/llm/messageInput'
import useAskPrixAi from '~/components/llm/hooks/useAskPrixAi'
import theme from '~/design'
import { useEffect, useRef, useState } from 'react'
import { SuggestedQuestions } from '~/components/llm/suggestedQuestions'

const EmptyMessagesArea = styled.div`
  flex: 1;
  flex-direction: column;
  width: 100%;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  font-size: 16px;
`

const NewChatMessageInput = styled.div`
  padding: 20px;
  width: 100%;

  @media screen and (max-width: 1150px) {
    padding: 0px;
  }
`

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 30px;
  text-align: center;
  color: ${theme.colors.primary};

  h2,
  p {
    margin: 0px;
  }

  span {
    color: ${theme.colors.secondary};
  }
`

export default function GeneralLlmChatCreateScreen() {
  const [input, setInput] = useState<string>('')
  const inputRef = useRef<HTMLTextAreaElement>(null)
  const { askPrixAi, isLoading } = useAskPrixAi()

  useEffect(() => {
    inputRef.current?.focus()
  }, [])

  const handleSendMessage = async (message: string) => {
    await askPrixAi(message)
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const form = e.target as HTMLFormElement
    const inputElement = form.querySelector('textarea')
    handleSendMessage(inputElement?.value ?? '')
  }

  return (
    <>
      <EmptyMessagesArea>
        <EmptyState>
          <h2>Prix AI</h2>
          <p>Selecione um chat ou comece uma nova conversa</p>
        </EmptyState>

        <NewChatMessageInput>
          <MessageInput
            inputRef={inputRef}
            input={input}
            setInput={setInput}
            onSubmit={handleSubmit}
            isLoading={isLoading}
          />
        </NewChatMessageInput>

        <SuggestedQuestions onSelect={handleSendMessage} disabled={isLoading} />
      </EmptyMessagesArea>
    </>
  )
}
